import { useNavigate } from "react-router-dom";
import { Invoice } from "../../../hooks/useInvoices";

const InvoiceCard = ({ invoice }: { invoice: Invoice }) => {
  const navigate = useNavigate();

  const dateObj = new Date(invoice.created_at);
  const date = dateObj.toLocaleDateString("ar-EG");
  const timeLabel = dateObj.toLocaleTimeString("ar-EG", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const totalPrice = invoice.order.items.reduce(
    (sum, item) => sum + Number(item.price),
    0
  );

  // استخلاص إجمالي المبلغ المستحق من الباك اند (قبل/بعد) لعرضه بشكل صحيح
  const orderTotals = (invoice as any)?.order?.total_price as
    | { total_before?: number; total_after?: number }
    | undefined;
  const backendTotalBefore =
    typeof orderTotals?.total_before === "number"
      ? orderTotals.total_before
      : undefined;
  const backendTotalAfter =
    typeof orderTotals?.total_after === "number"
      ? orderTotals.total_after
      : undefined;
  const backendSingleTotal =
    typeof (invoice as any)?.total_price === "number"
      ? ((invoice as any)?.total_price as number)
      : undefined;
  const discountApplied =
    (typeof backendTotalBefore === "number" &&
      typeof backendTotalAfter === "number" &&
      backendTotalBefore !== backendTotalAfter) ||
    ((invoice as any)?.discount_percentage || 0) > 0;
  const fmt = (n: number) => Number(n).toFixed(2);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // @ts-ignore: بعض الفواتير تأتي من الباك اند مع user_info داخل order
  const phone =
    (invoice.order as any).user_info?.phone ||
    invoice.user_info?.phone ||
    invoice.phone ||
    "غير متوفر";

  return (
    <div
      className='border-2 border-red-300 rounded-[20px] p-4 flex justify-between items-center hover:bg-red-50 text-right cursor-pointer'
      onClick={() => navigate(`/invoices/${invoice.id}`)}
    >
      {/* Right: Invoice info */}
      <div className='flex flex-col space-y-1 text-lg text-gray-800 text-right'>
        <div>فاتورة {invoice.id}</div>
        <div className='text-gray-500 text-sm'>رقم العميل: {phone}</div>
        <div>عدد الأصناف {invoice.order.items.length}</div>
        <div className='text-red-600 font-bold flex items-center gap-2 justify-start'>
          <span>المبلغ المستحق:</span>
          {discountApplied &&
          typeof backendTotalBefore === "number" &&
          typeof backendTotalAfter === "number" ? (
            <>
              {/* النهائي على اليمين، والقبل مشطوب على اليسار */}
              <span>{fmt(backendTotalAfter)} ريال</span>
              <span style={{ textDecoration: "line-through", color: "#888" }}>
                {fmt(backendTotalBefore)} ريال
              </span>
            </>
          ) : (
            <span>
              {fmt(
                backendSingleTotal ??
                  backendTotalAfter ??
                  backendTotalBefore ??
                  totalPrice
              )}{" "}
              ريال
            </span>
          )}
        </div>
      </div>

      {/* Left: Date + Time */}
      <div className='text-sm text-gray-500 space-y-1 text-center'>
        <div>{timeLabel}</div>
        <div className='text-red-600'>{date}</div>
      </div>
    </div>
  );
};

export default InvoiceCard;
